
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ChangelogDto_$reflection } from "../../Shared/Changelog.js";
import { record_type, lambda_type, unit_type, union_type, class_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { RequestedValue$1, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { getChangelogs } from "../../Requests/Changelog.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ChangelogTable } from "../Table/ChangelogTable.js";
import { singleton, empty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { singleton as singleton_1, empty as empty_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { IconButton } from "../../Components/Button.js";
import Order_History from "../../../public/assets/icons/Order_History.svg";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ChangelogFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.ChangelogModal.Msg", [], Msg, () => [[["Item", list_type(ChangelogDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(Changelogs, OnClose) {
        super();
        this.Changelogs = Changelogs;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.ChangelogModal.State", [], State, () => [["Changelogs", RequestedValue$1_$reflection(list_type(ChangelogDto_$reflection()))], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

function init(onClose, entityId) {
    return [new State(new RequestedValue$1(0, []), onClose), getChangelogs(entityId, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])))];
}

function update(msg, state) {
    if (msg.tag === 1) {
        return [state, Cmd_none()];
    }
    else {
        return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.OnClose), Cmd_none()];
    }
}

function Content(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(ChangelogTable, {
        Changelogs: props.Changelogs,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ChangelogModalSheet(props) {
    let elems, matchValue;
    return reactElement("div", createObj(singleton((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.OnClose, props.EntityId), update, (_arg_1, _arg_1_1) => {
        }), undefined, [props.IsOpen])[0].Changelogs, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Changelogs: matchValue.fields[0],
        })),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function OpenChangelogButtonModalSheet(props) {
    let elems;
    const patternInput = reactApi.useState(undefined);
    const setIsChangelogModalOpen = patternInput[1];
    const isChangelogModalOpen = patternInput[0];
    return reactElement("div", createObj(singleton((elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = isChangelogModalOpen, (matchValue == null) ? (empty_1()) : singleton_1(createElement(ChangelogModalSheet, {
            EntityId: matchValue,
            IsOpen: isChangelogModalOpen != null,
            OnClose: () => {
                setIsChangelogModalOpen(undefined);
            },
        }))), delay(() => singleton_1(createElement(IconButton, {
            ComponentState: "enabled",
            Icon: Order_History(),
            OnClick: () => {
                setIsChangelogModalOpen(props.EntityId);
            },
            TestId: "open-changelog-modal-icon-button",
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

